import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { NgModule } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';

import { AppRoutingModule } from "./app.routing";
import { GlowModule } from "./services/glowadminservices/glow.module";
import { PublicPagesModule } from "./public/public.module";

import { AuthGuard } from './auth-guard.service';
import { ConfigService } from "./services/app-config.service";

import { CacheService } from "./services/glowadminservices/cache.service";
import { ApplicationSelectorService } from "./services/app-selector.service";
import { ResourceService } from "./services/resource.service";
import { VirtualEntityService } from "./services/virtual-entity.service";
import { UIConfigService } from "./services/ui.service";
import { QrScanService } from "./services/qr-scan.service";

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        ClarityModule,        
        CommonModule,
        FormsModule,
        GlowModule,
        HttpModule,
        // PagesModule,
        PublicPagesModule,
    ],
    providers: [
        ApplicationSelectorService,
        AuthGuard,
        CacheService,
        ConfigService,  
        FormBuilder,
        QrScanService,
        ResourceService,
        VirtualEntityService,
        UIConfigService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
